<template>
    <section class="inventory-block">
        <section class="inventory-block--top">
            <section class="inventory-block--title">BOOK NAME</section>
            <section class="inventory-block--source">Source: Gyldendal</section>
        </section>
        <section class="inventory-block--titleinfo">Resource type: Book ISBN: 93423-3432-4234-2 Paper.</section>
        <section class="inventory-block--tableblock">
            <h4 class="inventory-block--availability">Physical availability</h4>
        <section>
            <section>TABLE HERE</section>
        </section>
        </section>
        <section class="inventory-block--bottom">
            <section><ui-icon name="chevron-right"/></section>
            <section><a href="">View more</a></section>
        </section>
    </section>

</template>

<script>
    export default {
        name: 'inventory-block',
        props: ['order'],
    }
</script>

<style>

.inventory-block{
    border: solid 1px grey;
    padding: 4px;
}

.inventory-block--top{
    display:flex;
    justify-content: space-between;
    margin-bottom: 10px;
    margin-top: 10px;
}

.inventory-block--title{
    color:#2b75bb;
    font-weight:bold;
}

.inventory-block--titleinfo{
    margin-bottom:6px;
}

.inventory-block--tableblock{
    border: solid 1px grey;
    margin-bottom: 8px;
    margin-top: 10px;
    padding: 6px;
}

.inventory-block--availability{
    margin-top:-15px;
    background:white;
    width:140px;
    margin-bottom: 10px;
}

.inventory-block--bottom{
    display:flex;
    flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// InventoryBlock.vue?4b133046